import { render } from "./BatchSchedule.vue?vue&type=template&id=678de689&scoped=true"
import script from "./BatchSchedule.vue?vue&type=script&lang=js"
export * from "./BatchSchedule.vue?vue&type=script&lang=js"

import "./BatchSchedule.vue?vue&type=style&index=0&id=678de689&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678de689"]])

export default __exports__